import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import { Login as LoginLayout } from "./layouts";
import PrivateRoutes from "./PrivateRoutes";
import Login from "./pages/login";

import Cookies from "universal-cookie";
import { setUser } from "./redux/actions/authorization";
import { API_POST } from "./helpers/api";
import Form from "./pages/Portal/Form";
import Result from "./pages/Portal/Result";
const cookies = new Cookies();

const Cryptr = require("cryptr");
const cryptr = new Cryptr(process.env.REACT_APP_SANYKO);

function App() {
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.authorization.user);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cookieUserDc = cookies.get("user");
    let cookieUser = {};

    if (cookieUserDc) {
      try {
        let cooku = cryptr.decrypt(cookieUserDc);
        cookieUser = JSON.parse(cooku);
      } catch (err) {
        cookies.remove("user");
      }
    }
    if (!authUser.token && cookieUser.token) {
      dispatch(setUser(cookieUser));
    }
    setTimeout(() => {
      setLoading(false);
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    viewportSize();
  }, []);

  const handleAuthUser = async (ticket) => {
    try {
      const res = await API_POST("authentication/sso", {
        serviceName: process.env.REACT_APP_SERVICE_NAME,
        ticket,
      });
      dispatch(setUser(res?.data));
      cookies.set("ticket", ticket, {
        maxAge: 10800,
        httpOnly: true,
        secure: true,
      });
    } catch (err) {
      // console.log(err);

      if (
        window.confirm(
          "Kullanıcı hatası " + (err?.response?.data?.message || err)
        )
      ) {
        return window.location.replace(
          `${process.env.REACT_APP_CAS_URL}/cas/login?service=${process.env.REACT_APP_SERVICE_NAME}`
        );
      }
    }
  };

  const handleLoginRequest = (location) => {
    const queryParams = location.search.slice(1);
    const queryParamsArr = queryParams.split("=");
    if (queryParamsArr[0] !== "ticket" || !queryParamsArr[1].trim()) {
      return window.location.replace(
        `${process.env.REACT_APP_CAS_URL}/cas/login?service=${process.env.REACT_APP_SERVICE_NAME}`
      );
    }

    handleAuthUser(queryParamsArr[1]);
  };

  const viewportSize = () => {
    document.body.style.height = window.innerHeight + "px";
  };

  window.addEventListener("resize", viewportSize);

  return (
    !loading && (
      <>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnHover={false}
        />
        <Router>
          {authUser.token ? (
            <PrivateRoutes />
          ) : (
            <>
              <Switch>
                <Route
                  path="/"
                  exact
                  render={({ location }) => {
                    handleLoginRequest(location);
                  }}
                />
                <Route
                  path="/login"
                  render={({ location }) => (
                    <LoginLayout location={location}>
                      <Login />
                    </LoginLayout>
                  )}
                />
                <Route path="/portal" exact component={Form} />
                <Route path="/portal/result" exact component={Result} />
                <Route render={() => <Redirect to="/" />} />
              </Switch>
            </>
          )}
        </Router>
      </>
    )
  );
}

export default App;
